import React, { useState, useEffect } from 'react';
import './Services.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Services = () => {
    const [hoveredCard, setHoveredCard] = useState(null);

  const services = [
    {
      title: 'CAD Designers',
      description: 'Professional CAD design services for product development and engineering solutions.',
      details: 'Our expert CAD designers create precise 2D and 3D models, technical drawings, and product prototypes. We specialize in mechanical design, architectural drafting, and product visualization using industry-standard software.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Merchandisers',
      description: 'Strategic merchandising solutions to optimize product placement and sales performance.',
      details: 'Our merchandising experts help brands maximize retail impact through strategic product placement, visual merchandising, inventory management, and sales optimization across various retail channels.',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Social Media Managers',
      description: 'Comprehensive social media management to build your brand presence and engagement.',
      details: 'Our social media specialists create engaging content, manage multiple platforms, analyze performance metrics, and build meaningful connections with your audience to drive brand awareness and conversions.',
      image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Graphic Designers',
      description: 'Creative graphic design services for all your visual communication needs.',
      details: 'Our talented graphic designers create stunning visuals, brand identities, marketing materials, and digital assets that effectively communicate your message and captivate your target audience.',
      image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Product Marketing Associates',
      description: 'Strategic product marketing to drive awareness, adoption, and growth.',
      details: 'Our product marketing experts develop go-to-market strategies, conduct market research, create compelling messaging, and execute campaigns that successfully launch and promote your products.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Digital Marketers',
      description: 'Full-service digital marketing to amplify your online presence and drive results.',
      details: 'Our digital marketing specialists execute comprehensive online strategies including SEO, PPC, content marketing, email campaigns, and conversion optimization to maximize your digital ROI.',
      image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'US/UK Accountants / Bookkeepers',
      description: 'Professional accounting and bookkeeping services for US and UK markets.',
      details: 'Our certified accountants and bookkeepers provide accurate financial management, tax preparation, compliance support, and financial reporting tailored to US and UK business requirements.',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'E-commerce Managers',
      description: 'Complete e-commerce management to optimize your online store performance.',
      details: 'Our e-commerce specialists manage online stores, optimize product listings, handle inventory, implement marketing strategies, and analyze performance to maximize sales and customer satisfaction.',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      title: 'Voice Sales Associates',
      description: 'Professional voice sales services to drive conversions and customer relationships.',
      details: 'Our experienced voice sales associates excel in lead qualification, customer engagement, sales presentations, and relationship building to convert prospects into loyal customers.',
      image: 'https://images.unsplash.com/photo-1553484771-371a605b060b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    }
  ];

  const industries = [
    {
      icon: '👗',
      title: 'Fashion',
      description: 'Comprehensive solutions for fashion brands, from design to retail management.'
    },
    {
      icon: '🏥',
      title: 'Healthcare',
      description: 'Specialized services for healthcare providers and medical technology companies.'
    },
    {
      icon: '💄',
      title: 'Cosmetics',
      description: 'Beauty and cosmetics industry expertise for brand development and marketing.'
    },
    {
      icon: '🚛',
      title: 'Logistics',
      description: 'Supply chain and logistics solutions for efficient operations and delivery.'
    },
    {
      icon: '💰',
      title: 'Finance',
      description: 'Financial services support including accounting, compliance, and advisory.'
    },
    {
      icon: '🏨',
      title: 'Hospitality',
      description: 'Hospitality industry solutions for hotels, restaurants, and travel companies.'
    }
  ];

  return (
    <div className="services-page">
      {/* <Navbar /> */}
      
      {/* Hero Section */}
      <div className="services-hero">
        <div className="hero-background-elements">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
        </div>
        <div className="container text-center">
          <h1 className="services-hero-title">
"I believe in the power of outsourcing. In business, I look for economic castles protected by unbreachable moats.” – 
<span>
  <i>
    Warren Buffett
  </i>
</span>
</h1>
          {/* <p className="services-hero-subtitle">
            Expert talent solutions across diverse industries to accelerate your business growth and success.
          </p> */}
        </div>
      </div>

      {/* Services Grid */}
    

      {/* Industries Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Our Professional <span className="highlight">Services</span>
            </h2>
            <p className="section-subtitle">
              Expert talent solutions to accelerate your business growth and success across all industries.
            </p>
          </div>
          
          <div className="services-grid">
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('cad')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" stroke="currentColor" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="12" rx="1" />
                    <path d="M8 18h8" />
                    <path d="M12 7v5" />
                    <path d="M9 10h6" />
                    <path d="M3 20h18" />
                  </svg>
                </div>
                <h3>CAD Designers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'cad' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Create accurate, detailed garment and product designs</li>
                    <li><span className="checkmark">✓</span> Work with global fashion teams on seasonal collections</li>
                    <li><span className="checkmark">✓</span> Ensure production-ready designs for sampling & manufacturing</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('merchandisers')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M12,10H6V6H12V10Z"/>
                  </svg>
                </div>
                <h3>Merchandisers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'merchandisers' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Coordinate between design, production, and buyers</li>
                    <li><span className="checkmark">✓</span> Manage product development timelines & sourcing</li>
                    <li><span className="checkmark">✓</span> Track orders and ensure on-time delivery</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('social')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H12V9.5H18M5,10V14H11V10M12,11V15H18V11M5,15V19H11V15M12,16V20H18V16M5,5V9H11V5H5Z"/>
                  </svg>
                </div>
                <h3>Social Media </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'social' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Plan and execute campaigns across platforms</li>
                    <li><span className="checkmark">✓</span> Engage audiences and build brand presence</li>
                    <li><span className="checkmark">✓</span> Analyze performance metrics for growth</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('graphic')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,2A2,2 0 0,1 14,4V8L15,7L16,8V4A2,2 0 0,1 18,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H18A2,2 0 0,1 16,16V12L15,13L14,12V16A2,2 0 0,1 12,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2H12M4,4V16H12V4H4M18,4V16H20V4H18Z"/>
                  </svg>
                </div>
                <h3>Graphic Designers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'graphic' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Design visuals for digital & print campaigns</li>
                    <li><span className="checkmark">✓</span> Maintain brand consistency across creatives</li>
                    <li><span className="checkmark">✓</span> Collaborate with marketing and product teams</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('marketing')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z"/>
                  </svg>
                </div>
                <h3>Product Marketing </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'marketing' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Assist in product launches and campaigns</li>
                    <li><span className="checkmark">✓</span> Conduct competitor and market analysis</li>
                    <li><span className="checkmark">✓</span> Support cross-functional marketing initiatives</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('digital')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8" />
                    <circle cx="12" cy="12" r="4" />
                    <path d="M12 2v2" />
                    <path d="M12 20v2" />
                    <path d="M2 12h2" />
                    <path d="M20 12h2" />
                    <path d="M15 9l6-6" />
                    <path d="M21 3v4h-4" />
                  </svg>
                </div>
                <h3>Digital Marketers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'digital' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Manage SEO, SEM, and paid ad campaigns</li>
                    <li><span className="checkmark">✓</span> Optimize websites and landing pages for conversions</li>
                    <li><span className="checkmark">✓</span> Track KPIs and improve campaign performance</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('accounting')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                </div>
                <h3>US/UK Accountants</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'accounting' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Handle bookkeeping, reconciliations, and reporting</li>
                    <li><span className="checkmark">✓</span> Prepare P&L, balance sheets, and cash flow statements</li>
                    <li><span className="checkmark">✓</span> Ensure compliance with US/UK accounting standards</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('ecommerce')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17,18C17.5,18 18,18.4 18,19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19C6,18.4 6.4,18 7,18H17M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5H5.21L4.27,3H1Z"/>
                  </svg>
                </div>
                <h3>E-commerce </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'ecommerce' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Oversee product listings, pricing, and inventory</li>
                    <li><span className="checkmark">✓</span> Manage online sales channels (Amazon, Shopify, etc.)</li>
                    <li><span className="checkmark">✓</span> Improve customer experience and online revenue</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('voice')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1553484771-371a605b060b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
                  </svg>
                </div>
                <h3>Voice Sales Associates</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'voice' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Handle inbound/outbound calls for US/UK clients</li>
                    <li><span className="checkmark">✓</span> Build and maintain customer relationships</li>
                    <li><span className="checkmark">✓</span> Drive sales through effective communication</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('content')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                </div>
                <h3>Content Writers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'content' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> SEO-Optimized Content</li>
                    <li><span className="checkmark">✓</span> Blog & Article Writing</li>
                    <li><span className="checkmark">✓</span> Website Copy Creation</li>
                    <li><span className="checkmark">✓</span> Technical Documentation</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('data')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z"/>
                  </svg>
                </div>
                <h3>Data Analysts</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'data' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Business Intelligence</li>
                    <li><span className="checkmark">✓</span> Statistical Analysis</li>
                    <li><span className="checkmark">✓</span> Data Visualization</li>
                    <li><span className="checkmark">✓</span> Predictive Modeling</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div 
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('virtual')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)'}}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"/>
                  </svg>
                </div>
                <h3>Virtual Assistants</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'virtual' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Administrative Support</li>
                    <li><span className="checkmark">✓</span> Calendar Management</li>
                    <li><span className="checkmark">✓</span> Email Management</li>
                    <li><span className="checkmark">✓</span> Research & Documentation</li>
                  </ul>
                  <button className="home-learn-more-btn">
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}

      <div className="why-choose-section">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="services-section-title">
              Why choose to build a team in India with us?
            </h2>
            <p className="services-section-subtitle">
              We combine expertise, technology, and dedication to deliver exceptional results
            </p>
          </div>

          <div className="why-choose-grid">
            <div className="why-choose-item">
              <div className="why-choose-icon fast-results">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="why-choose-title">Around-the-Clock Productivity
</h3>
              <p className="why-choose-description">Take advantage of time zone differences. While your local team rests, we continue your operations—ensuring progress never sleeps.
</p>
            </div>

            <div className="why-choose-item">
              <div className="why-choose-icon proven-track">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="why-choose-title">Global Reach, Local Excellence
</h3>
              <p className="why-choose-description">With teams based in India, you effectively open a global branch - without the setup hassles. Extend your presence and influence across borders seamlessly.
</p>
            </div>

            <div className="why-choose-item">
              <div className="why-choose-icon expert-team" 
              style={{background: '#F39C12'}}
              >
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
              <h3 className="why-choose-title">Maximize Value, Not Costs
</h3>
              <p className="why-choose-description">Why pay more locally when the same (or better) results are possible remotely? Our pricing is competitive, clear, and built for ROI.</p>
            </div>

        
          </div>
        </div>
      </div>

      {/* CTA Section */}
      {/* <div className="services-cta">
        <div className="container text-center">
          <h2 className="cta-title">
            Ready to Transform Your Business?
          </h2>
          <p className="cta-subtitle">
            Get started with our professional services today and see the difference quality makes.
          </p>
          <div className="cta-buttons" 
          style={{
                justifyContent: 'center'

          }}
          >
            <button className="btn btn-primary">
              Get Free Quote
            </button>
            <button className="btn btn-secondary">
              Schedule Consultation
            </button>
          </div>
        </div>
      </div> */}
      
      {/* <Footer /> */}
    </div>
  );
};

export default Services;